import { React,  useEffect } from "react";
import { useInView } from "react-intersection-observer";

// const { useState, useEffect } = React;

function GalleryCard(props) {
  // const containerRef = useRef(null);
  // const [isView, setIsView] = useState(false);

  const { ref: myRef, inView: myElementIsVisible } = useInView({
    threshold: 0.25,triggerOnce : true, rootMargin: "100px 0px", root: null

  });

  useEffect(() => {
    //   const handleScroll = event => {
    //     let speed=0;
    //     //get the scroll position
    //     const scrollPosition = window.scrollY;
    //     //get the height of the page
    //     const pageHeight = document.body.scrollHeight - window.innerHeight;
    //      speed += pageHeight*0.0002;
    // let card = document.querySelectorAll(".gallery__img__inner");
    // card.forEach((card) => {
    //   card.style.transform = `translateY(${70*speed*scrollPosition / pageHeight}%)`;
    // });
    //     //  console.log(el)
    //     //  this.style.transform = `translateY(${70*speed*scrollPosition / pageHeight}%)`;
    //       }
    //       window.addEventListener("scroll", handleScroll, { passive: true });
    //       return () => window.removeEventListener("scroll", handleScroll);
    //     }, [ containerRef, options]);
  });

  return (
    <>
      <div
        className={`gallery__wrapper ${
          myElementIsVisible ? "animated" : "animation"
        }`} ref={myRef}
      >
        {/* <div className="gallery__wrapper"> */}

        <div className="gallery__wrapper__inner">
          {/* <div className={`gallery__img ${myElementIsVisible?'animated':'animation'}`}  */}
          <div className="gallery__img" >
            <img
              src={props.photo_icon}
              alt={props.photo_alt}
              className="gallery__img__inner"
              loading="lazy"
              style={{
                objectFit: "cover",
                objectPosition: "center",
                width: "100%",
                height: "100%",
              }}

              // style={{
              //     // backgroundImage: `url(${myElementIsVisible?props.photo_icon:null})`, height: "100%", width: "100%", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat"
              //     backgroundImage: `url(${props.photo_icon})`, height: "100%", width: "100%", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat"
              //   }}
            ></img>
          </div>
          <div className="highlightWork__caption__title">
            <p>{props.name} <i>{props.italics}</i>{props.name2}</p>
          </div>
          <div className="highlightWork__caption__subtitle">
            <p>
              <span>{props.category}</span> — {props.type}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
function HighlightCard(props) {
  // const containerRef = useRef(null);
  // const [isView, setIsView] = useState(false);

  const { ref: myRef, inView: myElementIsVisible } = useInView({
    threshold: 0.15,triggerOnce : true, rootMargin: "100px 0px", root: null
  });

  return (
    <>
      <div
        className={`highlightWork ${
          myElementIsVisible ? "animated" : "animation"
        }`}
      ref={myRef}>
        <div className="highlightWork__caption" >
          <div className="highlightWork__caption__wrapper">
            <div className="highlightWork__caption__title">
              <p>{props.name}</p>
            </div>

            <div className="highlightWork__caption__subtitle">
              <p>
                <span>{props.category}</span> — {props.type}
              </p>
            </div>
          </div>
        </div>
        <div className="highlightWork__wrapper">
          {/* <div className="highlightWork__wrapper__inner"> */}
          <div
            className="highlightWork__wrapper__inner__img"
            style={{
              // backgroundImage: `url(${myElementIsVisible?props.photo_icon:null})`, height: "100%", width: "100%", backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat"
              backgroundImage: `url(${props.photo_icon})`,
              height: "100%",
              width: "100%",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

// function scrollAnimation() {

//   document.addEventListener("scroll", (el) => {
//     let speed=0;
//     //get the scroll position
//     const scrollPosition = window.scrollY;
//     //get the height of the page
//     const pageHeight = document.body.scrollHeight - window.innerHeight;
//      speed += pageHeight*0.0002;

//      console.log(el)
//      this.style.transform = `translateY(${70*speed*scrollPosition / pageHeight}%)`;

//   });
// }

// scrollAnimation();

export { GalleryCard, HighlightCard };
